import React from 'react';
// import classnames from 'classnames';
import PropTypes from 'prop-types';
import MaskedInput from 'react-input-mask';

const CardInputMaskinking = ({
    field, value, label, id, error, type, onChange, mask, disabled, divClassName, viewPassword, placeholder, passwordStatus, req
}) => (


        <div className={divClassName}>

            <MaskedInput className="form-control validate" maskChar="" mask={mask} name={field} value={value} onChange={onChange} />
            <label className="active" htmlFor={label}>{label}</label>
            {error && <span className="help-block invalid ">{error}</span>}


            {/* <input id="Email" type="text" placeholder="placeholder" className="validate" /> */}

        </div>
    );

CardInputMaskinking.propTypes = {
    field: PropTypes.string,
    value: PropTypes.any,
    label: PropTypes.string,
    error: PropTypes.any,
    type: PropTypes.string,
    divClassName: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.any,
    mask: PropTypes.any,
    viewPassword: PropTypes.func,
    req: PropTypes.any,
    passwordStatus: PropTypes.any
};

CardInputMaskinking.defaultProps = {
    type: 'text',
    disabled: false,
    req: false,
    passwordStatus: false,
    divClassName: '',
    id: '',
};

export default CardInputMaskinking;
